import withAuthGuard from '@hocs/withAuthGuard';
import withVerificationGuard from '@hocs/withVerificationGuard';
import { flowRight } from 'lodash';

import APIKeysUpdatePage from './APIKeysUpdatePage';

export default flowRight(withVerificationGuard, withAuthGuard())(APIKeysUpdatePage);
